import React from "react";
export const PermissionsIcon = () => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.92593L6.5 1L1 2.92593V9.08889C1 11.0148 3.13889 14 6.5 14C9.86111 14 12 10.5333 12 9.08889V2.92593Z"
      stroke="black"
    />
    <line x1="6.5" y1="3" x2="6.5" y2="12" stroke="black" />
  </svg>
);
